import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { OtpComponent } from './otp/otp.component';
const routes: Routes = [
  { path:'register',component:RegisterComponent },
  { path:'otp',component:OtpComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ModuleRoutingModule { }
